import { appConfig } from '@/utils/app-config'
import { useAuthStore } from '@/stores/auth'

export interface OpenTemplateViewReportOptions {
  /**
   * 报表窗口名称。传入非特殊窗口名时，浏览器会保留 window.opener，
   * 供报表页在导出完成后通过 postMessage 回传文件信息。
   */
  target?: string
}

/**
 * 打开模板查看报表
 * @param template 选中的模板
 * @param templateParams 报表业务参数
 * @param options 窗口打开配置
 */
export function openTemplateViewReport(
  template: any,
  templateParams: any = {},
  options: OpenTemplateViewReportOptions = {}
) {
  try {
    console.log('[CT_TEMPLATE] 打开模板查看报表:', template)

    // 获取必要的认证信息
    const jwtToken = useAuthStore().token
    const userType = useAuthStore().user?.userType?.toString() || ''

    if (!jwtToken) {
      throw new Error('未找到认证信息')
    }

    // 构建查看报表的URL
    // NOTE: 开发打印功能时，可以临时改为 /report/designer 设计模式，用于调试数据源
    const viewReportUrl = `${appConfig.reportServerHost}/report/view`

    // 创建隐藏的表单
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = viewReportUrl
    // `_blank` 会使新页面的 window.opener 为空，运输委托单导出完成后无法回传文件信息。
    // 保存文件管理场景传入唯一命名窗口，其他调用方继续沿用原来的 `_blank` 行为。
    form.target = options.target || '_blank'
    form.style.display = 'none'

    // 辅助函数：添加隐藏字段
    const addHiddenField = (name: string, value: string) => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = name
      input.value = value
      form.appendChild(input)
    }

    // 补充额外模板参数
    const extraParams = Object.entries(templateParams)
      .filter(([key, value]) => value !== null && value !== undefined && value !== '')
      .map(([key, value]) => [key, value.toString()])
    console.log('[CT_TEMPLATE] 补充额外模板参数:', extraParams)

    // 添加必要的参数
    const paramMap = new Map<string, string>([
      ['ACTION', 'view'],
      ['TEMPALTE_TYPE', template.templateType || ''],
      ['sessionId', jwtToken],
      ['reqSource', 'control-tower'],
      ['userType', userType],
      ['printSource', ''],
      ['LANGUAGE', 'zh'],
      ['___SESSION_ID', jwtToken],
      ['___REQ_SOURCE', 'control-tower'],
      ['___USER_TYPE', userType],
      ['___TEMPLATE_ID', template.id?.toString() || ''],
      ['___SCHEMA_TYPE', template.schemaType || ''],
      ['___CLOUD_FILE_PREFIX', template.name || ''],
      ['___DESIGN_MODE', '0'], // 0表示查看模式，1表示设计模式
      ['___STORAGE_FILE_ID', template.documentId || ''],
      ['remarks', '固定值'],
      ['___EMAIL_TO', ''],
      ['___EMAIL_CC', ''],
      ['___EMAIL_SUBJECT', ''],
      ['___EMAIL_CONTENT', ''],
      ['showPreview', "'true'"],
      ['printType', "'VIEW'"],
      ['designMode', "'0'"],
      ['zone', 'Asia/Shanghai'],
      ...extraParams
    ])

    console.log('[CT_TEMPLATE] 查看报表请求参数:', paramMap)

    // 添加所有表单参数
    paramMap.forEach((value, key) => {
      addHiddenField(key, value)
    })

    // 构建 ___PARAMSTRS 字段
    const paramStrs = Array.from(paramMap.entries())
      .filter(([key]) => key !== '___PARAMSTRS')
      .map(([key, value]) => `${key}=${value}`)
      .join('&')

    addHiddenField('___PARAMSTRS', paramStrs)

    console.log('[CT_TEMPLATE] 构建的参数字符串:', paramStrs)

    // 提交表单
    document.body.appendChild(form)
    form.submit()
    document.body.removeChild(form)

    console.log('[CT_TEMPLATE] 成功提交表单，打开查看报表页面')
    return true
  } catch (error) {
    console.error('[CT_TEMPLATE] 打开查看报表失败:', error)
    throw error
  }
}
